import { Card, CardContent } from "../../ui/card";
import { formatInternationalPhone } from "../../../utlis/summaryhelpers";
function InfoChip({ label, value, className }) {
  const containerClass =
    (className
      ? className
      : "rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal w-full sm:w-auto") +
    " overflow-hidden"
 return (
    <span
      className={
        (className
          ? className
          : "flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-none w-full sm:w-auto") +
        " break-words min-w-0"
      }
    >
      <span className="text-[#000009] flex items-center justify-center shrink-0">
        {label}
      </span>
      <span className="ml-2 font-medium text-[#005787] break-all min-w-0">
        {value}
      </span>
    </span>
  );
}

export default function ApplicantCard({
  fullName,
  visaType,
  visaStatus,
  nationality,
  currentResidence,
  phone,
  email,
  country,
  city,
  suburb,
  visaDetails,
}) {
  return (
    <Card className="w-full shadow-none border-none p-0 h-fit mb-12">
      <CardContent className="p-0 w-full">
        <div className="w-full flex flex-wrap gap-2 sm:gap-3 justify-start">
          <InfoChip
            className="w-full flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
            label="Full Name:"
            value={fullName}
          />
          <InfoChip
            className="w-full flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
            label="Nationality:"
            value={nationality}
          />
          <span className="w-full flex items-center justify-center gap-2 flex-wrap">
            <InfoChip
              className="flex-1 min-w-[150px] flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
              label="Country:"
              value={country}
            />
            <InfoChip
              className="flex-1 min-w-[150px] flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
              label="City:"
              value={city}
            />
            <InfoChip
              className="flex-1 min-w-[150px] flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
              label="Suburb:"
              value={suburb}
            />
          </span>
          <InfoChip
            className="w-full flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
            label="Residence:"
            value={currentResidence}
          />
          <span className="w-full flex items-center justify-center gap-2 flex-wrap">
            <InfoChip
              className="flex-1 min-w-[150px] flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
              label="Email:"
              value={email}
            />
            <InfoChip
              className="flex-1 min-w-[150px] flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
              label="Phone:"
              value={formatInternationalPhone(phone)}
            />
          </span>
          <InfoChip
            className="w-full flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
            label="Visa Category:"
            value={visaType}
          />
          {visaType === "Other" && (
            <InfoChip
              className="w-full flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
              label="Visa Details:"
              value={visaDetails}
            />
          )}
          <InfoChip
            className="w-full flex items-center justify-start rounded-md border border-[#000000] bg-card px-3 py-2 text-xs sm:text-sm md:text-[15px] lg:text-[16px] leading-normal overflow-hidden"
            label="Visa Status:"
            value={visaStatus}
          />
        </div>
      </CardContent>
    </Card>
  );
}
